<div class="row mt-3">
    <app-loader *ngIf="showLoader"></app-loader>
    <div class="col" *ngIf="modelDescription">
        <div class="field mb-3">
            <label>Model:</label>
            <p class="pt-2">{{ modelDescription }}</p>
        </div>
    </div>
    <div class="col" *ngIf="serialNumber">
        <div class="field mb-3">
            <label>Serial Number:</label>
            <p class="pt-2">{{ serialNumber }}</p>
        </div>
    </div>
    <div class="col">
        <div class="field mb-3">
            <label>Warranty:</label>
            <ng-container *ngIf="warrantyInfo">
                <div class="text-white {{ desc.class }} ps-2 bg-coverage-gradient" *ngFor="let desc of warrantyInfo">
                    <div *ngIf="desc.costType === 'No coverage'">
                        <span>{{desc.costType}}</span>
                    </div>
                    <div *ngIf="desc.costType !== 'No coverage'">
                        <span class="warranty-cost-type">  {{ desc.costType }}</span> :
                        <span class="warranty-percentage-coverage"> {{ desc.percentageCoverage }}% </span> -
                        <span class="warranty-effective-date">{{ desc.effectiveDate | date }} </span>
                        <span class="warranty-expiry-date"> to {{ desc.expiryDate | date }} </span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="col">
        <div class="field mb-3">
            <label>Contract:</label>
            <ng-container *ngIf="contractInfo">
                <div class="text-white {{ desc.class }} ps-2 bg-coverage-gradient" *ngFor="let desc of contractInfo">
                    <span class="contract-cost-type"> {{ desc.costType }}</span>
                    <span class="contract-percentage-coverage" *ngIf="desc.costType !== 'No coverage'">:  {{ desc.percentageCoverage }}% -</span>
                    <span class="contract-effective-date" *ngIf="desc.costType !== 'No coverage'"> {{ desc.effectiveDate | date : 'd MMM, y'}} |</span>
                    <span class="contract-expiry-date" *ngIf="desc.costType !== 'No coverage'"> {{ desc.expiryDate | date : 'd MMM, y'}} </span>
                </div>
            </ng-container>

        </div>
    </div>
    <div class="col">
        <div class="field mb-3">
            <div class="text-start"><label class="fw-bold">Approved Amount:</label>
                <span class="ms-3">{{ data.approvedAmount | currency : customerCurrency}}</span>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header d-flex ps-0" data-bs-toggle="collapse" href="#collapseAssignmentsTransactions">
                <a class="card-link flex-fill">Assignments/Transactions</a>
                <i class="fas fa-chevron-up"></i>
            </div>
            <div id="collapseAssignmentsTransactions" class="collapse show">
                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-12">
                            <!-- Assignments on @inavista/components: rows are this.assignments (LocalRowsGridApi), saved with the popup. -->
                            @if (ddlFetched && assignmentsConfig) {
                                <div class="assignments-grid" (dblclick)="onAssignmentDoubleClick()">
                                    <inavista-grid #assignmentsGrid class="so-popup-grid"
                                        [config]="assignmentsConfig"
                                        [actionIcons]="assignmentsActionIcons"
                                        (rowClick)="lastClickedAssignment = $event.row"
                                        (rowEditStart)="onAssignmentEditStart($event.row)"
                                        (dirtyChange)="assignmentEditing = $event.dirty"
                                        (rowCommit)="onAssignmentCommit($event)"
                                        (rowRevert)="onAssignmentRevert()"
                                        (actionIconClick)="onAssignmentActionIconClick($event)"
                                        (toolbarActionClick)="onAssignmentsToolbarAction($event)" />
                                </div>
                            }
                        </div>
                        <div class="col-12 mt-3">
                            <!-- Transactions on @inavista/components: rows are this.assignmentDetails (LocalRowsGridApi); each cell shows its
                                 column's own editor (txEditor templates below), so the editors' rules run as before. -->
                            @if (ddlFetched && transactionsConfig) {
                                <div class="transactions-grid" (dblclick)="onTransactionDoubleClick()">
                                    <inavista-grid #transactionsGrid class="so-popup-grid"
                                        [config]="transactionsConfig"
                                        [actionIcons]="transactionsActionIcons"
                                        (rowClick)="lastClickedTransaction = $event.row"
                                        (rowEditStart)="onTransactionEditStart($event)"
                                        (rowCommit)="onTransactionCommit($event)"
                                        (rowRevert)="onTransactionRevert($event)"
                                        (actionIconClick)="onTransactionActionIconClick($event)"
                                        (hyperlinkClick)="onTransactionHyperlink($event)"
                                        (toolbarActionClick)="onTransactionsToolbarAction($event)" />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header d-flex ps-0" data-bs-toggle="collapse" href="#collapseDetails">
                <a class="card-link flex-fill">Details</a>
                <i class="fas fa-chevron-up"></i>
            </div>
            <div id="collapseDetails" class="collapse show">
                <div class="card-body pb-0">
                    <div class="row">
                        <div class="col-3">
                            <div class="field mb-1 p-2" style="background-color: #a5d2fe;">
                                <label class="details-amount">My Claim Amount ({{ customerCurrency }}):<b class="fw-bold"> {{ data.totalClaimAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3 pt-2">
                            <div class="field mb-1">
                                <label class="details-amount">Discount Amount ({{customerCurrency}}):<b class="fw-bold"> {{ data.discountAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3 pt-2">
                            <div class="field mb-1">
                                <label class="details-amount">Warranty Coverage ({{customerCurrency}}):<b class="fw-bold"> {{ data.warrantyCoverage | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3 pt-2">
                            <div class="field mb-1">
                                <label class="details-amount">Contract Coverage ({{customerCurrency}}):<b class="fw-bold"> {{ data.contractCoverage | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <div class="field mt-2 mb-1">
                                <label class="details-amount">Sales Amount ({{customerCurrency}}):<b class="fw-bold"> {{ data.salesAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="field mt-2 mb-1">
                                <label class="details-amount">Total Amount ({{ customerCurrency }}):<b class="fw-bold"> {{ data.totalAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="field mt-2 mb-1">
                                <label class="details-amount">Tax ({{ customerCurrency }}):<b class="fw-bold"> {{ data.tax | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="field mt-2 mb-1">
                                <label class="fw-bold details-amount">Invoice Amount ({{ customerCurrency }}):<b class="fw-bold"> {{ data.invoiceAmount | currency : customerCurrency}}</b></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-isc-assignments-popup
  *ngIf="showAssignmentsPopup"
  [data]="selectedAssignment"
  [assignments]="assignments"
  [assignmentDetails]="assignmentDetails"
  [equipmentInfo]="equipmentInfoData"
  [soCreatedDate]="data.soCreatedDate"
  [referenceActivities]="referenceActivities"
  [reportedProblems]="reportedProblems"
  [solutions]="solutions"
  [priorities]="priorities"
  (onClose)="selectedAssignment = null; showAssignmentsPopup = false;"
  (onSave)="saveAssignment($event)"
></app-isc-assignments-popup>

<app-isc-assignment-details-popup
  *ngIf="showAssignmentDetailsPopup"
  [costTypes]="costTypes"
  [taxRates]="taxRates"
  [checkinTime]="checkinTime"
  [technicianId]="$safeNavigationMigration(data?.technicianId)"
  [assignments]="assignments"
  [assignmentDetails]="assignmentDetails"
  [loadedAssignmentItemDetails]="loadedAssignmentItemDetails"
  [equipmentInfo]="equipmentInfoData"
  [soCreatedDate]="data.soCreatedDate"
  [serviceOrderId]="data.serviceOrderId"
  [data]="selectedAssignmentDetail"
  [units]="units"
  [returnReasons]="returnReasons"
  [distanceZone]="distanceZone"
  [configurationId]="configurationId"
  [customerCode]="data.customerCode"
  (onClose)="showAssignmentDetailsPopup = false; selectedAssignmentDetail = null;"
  (onSave)="saveAssignmentDetail($event)"
></app-isc-assignment-details-popup>

<ng-template #assignmentTemplate let-data>
  <div class="e-list-item" [title]="data.description">{{data.description}}</div>
</ng-template>

<ng-template #cartWithCounter>
  <i class="fa fa-shopping-cart" aria-hidden="true"></i>
  <span class="badge-red">
    <span class="e-badge e-badge-overlap e-badge-notification e-badge-circle count-position">{{cartCount}}</span>
  </span>
</ng-template>

<app-items-advanced-search
  *ngIf="showItemAdvancedSearchPopup"
  [technicianId]="$safeNavigationMigration(data?.technicianId)"
  [serviceItemGroup]="serviceItemGroup"
  (onClose)="onItemAdvancedSearchPopupClose($event)"
></app-items-advanced-search>

<app-cart-checkout-popup
  *ngIf="showCartCheckoutPopup"
  [recievedItems]="fromExecutionTab"
  [serviceOrderId]="data.serviceOrderId"
  [onsiteAddress]="onsiteAddressForPurchaseOrder"
  (onClose)="showCartCheckoutPopup = false;"
></app-cart-checkout-popup>

<app-parts-catalog-popup
  *ngIf="showPartsCatalogPopup"
  [serviceOrderId]="data.serviceOrderId"
  [onsiteAddress]="onsiteAddressForPurchaseOrder"
  [currency]="USER.orderCurrency"
  (onClose)="showPartsCatalogPopup = false;"
></app-parts-catalog-popup>


<!-- Assignments grid editors. Each dropdown shows the list's text and also writes the code the order stores. -->
<ng-template #refActivityEditor let-row let-draft="draft" let-setValue="setValue" let-setRawCell="setRawCell">
    @if (refActivityEditorShown) {
        <inavista-dropdown [options]="refActivityOptions" [value]="draft?.referenceActivityCode" panelWidth="250px" [listOverlay]="true" listPosition="auto" [openOnFocus]="true"
            (valueChange)="onRefActivityPicked($event, { row, setValue, setRawCell })" />
    }
</ng-template>
<ng-template #reportedProblemEditor let-draft="draft" let-setValue="setValue" let-setRawCell="setRawCell">
    <inavista-dropdown [options]="reportedProblemOptions" [value]="draft?.reportedProblem" panelWidth="250px" [listOverlay]="true" listPosition="auto" [openOnFocus]="true"
        (valueChange)="onListPicked(reportedProblems, 'description', 'reportedProblem', $event, { setValue, setRawCell })" />
</ng-template>
<ng-template #solutionEditor let-draft="draft" let-setValue="setValue" let-setRawCell="setRawCell">
    <inavista-dropdown [options]="solutionOptions" [value]="draft?.solutionCode" panelWidth="250px" [listOverlay]="true" listPosition="auto" [openOnFocus]="true"
        (valueChange)="onListPicked(solutions, 'text', 'solutionCode', $event, { setValue, setRawCell })" />
</ng-template>
<ng-template #priorityEditor let-draft="draft" let-setValue="setValue" let-setRawCell="setRawCell">
    <inavista-dropdown [options]="priorityOptions" [value]="draft?.priority" panelWidth="250px" [listOverlay]="true" listPosition="auto" [openOnFocus]="true"
        (valueChange)="onListPicked(priorities, 'text', 'priority', $event, { setValue, setRawCell })" />
</ng-template>
<!-- Start can't be before the stored start (or now), and End can't be before Start, as before. -->
<ng-template #startDateEditor let-row let-draft="draft" let-setRawValue="setRawValue">
    <inavista-date-picker mode="datetime" placeholder="Select start date time..." [min]="row.startDate || assignmentEditStartedAt"
        [max]="draft?.endDate || null" [value]="draft?.startDate || null" (valueChange)="setRawValue($event)" />
</ng-template>
<ng-template #endDateEditor let-row let-draft="draft" let-setRawValue="setRawValue">
    <inavista-date-picker mode="datetime" placeholder="Select end date time..." [min]="draft?.startDate || row.startDate || assignmentEditStartedAt"
        [value]="draft?.endDate || null" (valueChange)="setRawValue($event)" />
</ng-template>


<!-- The open transaction's hidden columns: their editors, out of sight, as the old grid had them. -->
@if (txHiddenRow) {
    <div class="d-none" aria-hidden="true">
        @for (field of txHiddenEditFields; track field) {
            <app-cell-editor [edit]="txEditDef(field)" [field]="field" [rowData]="txHiddenRow" [registry]="txOpenEditors" />
        }
    </div>
}

<!-- Transactions grid: one template per cell drawn with its column's editor (CellEditorHost, @inavista/components controls). -->
@for (field of txEditFields; track field) {
    <ng-template #txEditor let-row>
        <app-cell-editor class="tx-cell-editor" [edit]="txEditDef(field)" [field]="field" [rowData]="transactionRowFor(row)" [registry]="txOpenEditors" />
    </ng-template>
}